import specialSourceControll from "../components/specialSourceControll";
import forgotPassword from "../components/forgotPassword";
import course from "./course";
import mine from "./mine";
import special from "./special";
import other from "./other";
import login from "./login";

const components = [
  specialSourceControll,
  forgotPassword,
  ...course,
  ...mine,
  ...special,
  ...other,
  ...login,
];
function install(Vue) {
  components.forEach((it) => {
    Vue.component(it.name, it);
    if (!window.$components['nc']) {
      window.$components['nc'] = {}
    }
    window.$components['nc'][it.name] = it;
  })
}

if (typeof window !== "undefined" && window.Vue) {
  install(window.Vue);
}

export {
  install
};

export default install